export enum ADMIN_MESSAGE_TYPE {
    Login = "admin_login",
    Logout = "admin_logout"
}